import { ModelBase } from 'store/model-base';
import { PendingLineTransferBanner } from 'my-account/constants';

export class LineBannerInfo extends ModelBase {
    public static storeName: string = 'lineBanner';
    public static idAttribute: string = 'id';

    public id: string;
    public lineId: string;  // lineId would be id.key of line, which we manually add to model
    public nickname: string;
    public subheader: Header;
    public description: Header;
    public ctaButton: CtaButton;

    public static create<T extends ModelBase>(response: ApiResponse): T {
        if (response.subheader) {
            response.subheader.dataUsed = response.subheader.dataUsed || '';
            response.subheader.dataCost = response.subheader.dataCost || '';
            response.subheader.nickname = response.subheader.nickname || '';
            response.subheader.paymentDate = response.subheader.paymentDate || '';
            response.subheader.amount = response.subheader.amount || '';
            response.subheader.throttleLimit = response.subheader.throttleLimit || '';
            response.subheader.nextCycleStartMonth = response.subheader.nextCycleStartMonth || '';
            response.subheader.nextCycleStartDate = response.subheader.nextCycleStartDate || '';
        } else {
            response.subheader = {
                dataCost: '',
                dataUsed: '',
                throttleLimit: '',
                nickname: '',
                amount: '',
                paymentDate: '',
                nextCycleStartDate: '',
                nextCycleStartMonth: ''
            };
        }

        if (!response.description) {
            response.description = {};
        }

        return super.create<T>(response);
    }

    public get isLineTransferPendingBanner(): boolean {
        return (this.id === PendingLineTransferBanner.ACCOUNT_PENDING_LINE_TRANSFER
            || this.id === PendingLineTransferBanner.CB_ACCOUNT_PENDING_LINE_TRANSFER
            ||this.id === PendingLineTransferBanner.CB_LINE_PENDING_TRANSFER
            ||this.id === PendingLineTransferBanner.LINE_PENDING_TRANSFER);
    }
}
